import React from 'react';

export function Body({ children }: { children?: React.ReactNode }) {
  return <>{children}</>;
}
Body.displayName = 'FullLayout.Body';
